import { Extension } from '@tiptap/react'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'
import { filterTokenPattern } from 'helpers/filter-interpolation'
import { dataFieldTokenPattern } from 'helpers/data-field-tokens'

// Renders {{filter::…}} placeholders in the text chart editor as chips so an
// inserted data field reads as one taggable unit rather than as punctuation the
// author might edit by hand.
//
// This is a ProseMirror decoration, not a node or a mark: text charts are saved
// as HTML and sanitized server-side against a tag/attribute allowlist that keeps
// only style/colspan/rowspan/scope (see DashboardTextChart::ALLOWED_ATTRIBUTES),
// so a real node's data attributes would be stripped on save and the chip would
// not survive a reload. Decorations are view-only, so the stored content stays
// the plain text the interpolators already understand.

const decorateDoc = (doc) => {
  const decorations = []

  doc.descendants((node, pos) => {
    if (!node.isText || !node.text) return

    // Both grammars chip: a data field and a filter value read the same way in
    // the text, and an undecorated one would invite hand-editing.
    ;[filterTokenPattern(), dataFieldTokenPattern()].forEach((pattern) => {
      let match = pattern.exec(node.text)
      while (match !== null) {
        decorations.push(
          Decoration.inline(
            pos + match.index,
            pos + match.index + match[0].length,
            { class: 'filter-token' }
          )
        )
        match = pattern.exec(node.text)
      }
    })
  })

  return DecorationSet.create(doc, decorations)
}

const pluginKey = new PluginKey('filterTokenHighlight')

export const FilterTokenHighlight = Extension.create({
  name: 'filterTokenHighlight',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: pluginKey,
        state: {
          init: (_config, { doc }) => decorateDoc(doc),
          apply: (tr, previous) => (tr.docChanged ? decorateDoc(tr.doc) : previous)
        },
        props: {
          decorations(state) {
            return pluginKey.getState(state)
          }
        }
      })
    ]
  }
})
